(function () {
  const MOBILE_BREAKPOINT = 749;
  const TABLET_BREAKPOINT = 1199;
  const MOBILE_START_INDEX = 1;
  const SWIPE_DISTANCE = 45;
  const AUTOPLAY_INTERVAL = 4000;

  function initPeguuTestimonials(section) {
    if (!section || section.dataset.carouselInitialized === "true") {
      return;
    }

    const viewport = section.querySelector(
      ".peguu-testimonials__viewport"
    );

    const track = section.querySelector(
      ".peguu-testimonials__track"
    );

    const cards = Array.from(
      section.querySelectorAll(".peguu-testimonial-card")
    );

    const dotsContainer = section.querySelector(
      ".peguu-testimonials__dots"
    );

    if (!viewport || !track || !cards.length || !dotsContainer) {
      return;
    }

    section.dataset.carouselInitialized = "true";

    let currentPage = 0;
    let itemsPerPage = 3;
    let pageCount = 1;
    let isMobile = false;
    let mobileWasInitialized = false;
    let autoplayTimer = null;

    let pointerStartX = 0;
    let pointerCurrentX = 0;
    let pointerStartOffset = 0;
    let isDragging = false;

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function getTargetCardIndex() {
      return Math.min(
        currentPage * itemsPerPage,
        cards.length - 1
      );
    }

    function getCurrentOffset() {
      const targetCard = cards[getTargetCardIndex()];

      if (!targetCard) {
        return 0;
      }

      if (isMobile) {
        const centeredSpace =
          (viewport.clientWidth - targetCard.offsetWidth) / 2;

        return targetCard.offsetLeft - centeredSpace;
      }

      return targetCard.offsetLeft;
    }

    function updateDots() {
      const dots = dotsContainer.querySelectorAll("button");

      dots.forEach(function (dot, index) {
        const isActive = index === currentPage;

        dot.classList.toggle("is-active", isActive);

        if (isActive) {
          dot.setAttribute("aria-current", "true");
        } else {
          dot.removeAttribute("aria-current");
        }
      });
    }

    function moveCarousel(animate = true) {
      const offset = getCurrentOffset();

      track.style.transition = animate
        ? "transform 0.4s ease"
        : "none";

      track.style.transform =
        `translate3d(-${offset}px, 0, 0)`;

      updateDots();

      if (!animate) {
        requestAnimationFrame(function () {
          track.style.transition = "";
        });
      }
    }

    function startAutoplay() {
      window.clearInterval(autoplayTimer);

      if (pageCount <= 1) {
        autoplayTimer = null;
        return;
      }

      autoplayTimer = window.setInterval(function () {
        currentPage = (currentPage + 1) % pageCount;
        moveCarousel(true);
      }, AUTOPLAY_INTERVAL);
    }

    function goToPage(pageIndex) {
      currentPage = clamp(
        pageIndex,
        0,
        pageCount - 1
      );

      moveCarousel(true);
      startAutoplay();
    }

    function createDots() {
      dotsContainer.innerHTML = "";

      for (let index = 0; index < pageCount; index += 1) {
        const button = document.createElement("button");

        button.type = "button";
        button.dataset.slide = String(index);

        if (isMobile) {
          button.setAttribute(
            "aria-label",
            `Ver reseña ${index + 1}`
          );
        } else {
          const firstReview = index * itemsPerPage + 1;
          const lastReview = Math.min(
            firstReview + itemsPerPage - 1,
            cards.length
          );

          button.setAttribute(
            "aria-label",
            `Ver reseñas ${firstReview} a ${lastReview}`
          );
        }

        button.addEventListener("click", function () {
          goToPage(index);
        });

        dotsContainer.appendChild(button);
      }
    }

    function configureCarousel() {
      const newIsMobile =
        window.innerWidth <= MOBILE_BREAKPOINT;

      const modeChanged = newIsMobile !== isMobile;

      isMobile = newIsMobile;
      itemsPerPage = isMobile
        ? 1
        : window.innerWidth <= TABLET_BREAKPOINT
          ? 2
          : 3;
      pageCount = Math.ceil(cards.length / itemsPerPage);

      if (isMobile && !mobileWasInitialized) {
        currentPage = Math.min(
          MOBILE_START_INDEX,
          pageCount - 1
        );

        mobileWasInitialized = true;
      } else if (modeChanged && !isMobile) {
        currentPage = 0;
      } else {
        currentPage = clamp(
          currentPage,
          0,
          pageCount - 1
        );
      }

      createDots();

      requestAnimationFrame(function () {
        moveCarousel(false);
        startAutoplay();
      });
    }

    function finishDrag() {
      if (!isDragging) {
        return;
      }

      const movement = pointerCurrentX - pointerStartX;

      isDragging = false;
      viewport.classList.remove("is-dragging");

      if (Math.abs(movement) >= SWIPE_DISTANCE) {
        if (movement < 0) {
          goToPage(currentPage + 1);
        } else {
          goToPage(currentPage - 1);
        }
      } else {
        moveCarousel(true);
      }
    }

    viewport.addEventListener("pointerdown", function (event) {
      if (event.pointerType === "mouse" && event.button !== 0) {
        return;
      }

      isDragging = true;
      pointerStartX = event.clientX;
      pointerCurrentX = event.clientX;
      pointerStartOffset = getCurrentOffset();

      track.style.transition = "none";
      viewport.classList.add("is-dragging");

      viewport.setPointerCapture(event.pointerId);
    });

    viewport.addEventListener("pointermove", function (event) {
      if (!isDragging) {
        return;
      }

      pointerCurrentX = event.clientX;

      const movement = pointerCurrentX - pointerStartX;
      const translatedPosition =
        -pointerStartOffset + movement;

      track.style.transform =
        `translate3d(${translatedPosition}px, 0, 0)`;
    });

    viewport.addEventListener("pointerup", finishDrag);
    viewport.addEventListener("pointercancel", finishDrag);
    viewport.addEventListener("lostpointercapture", finishDrag);

    viewport.setAttribute("tabindex", "0");

    viewport.addEventListener("keydown", function (event) {
      if (event.key === "ArrowRight") {
        goToPage(currentPage + 1);
      }

      if (event.key === "ArrowLeft") {
        goToPage(currentPage - 1);
      }
    });

    let resizeTimeout;

    window.addEventListener("resize", function () {
      clearTimeout(resizeTimeout);

      resizeTimeout = setTimeout(function () {
        configureCarousel();
      }, 120);
    });

    configureCarousel();
  }

  function initAllTestimonials(root) {
    const sections = root.querySelectorAll
      ? root.querySelectorAll(".peguu-testimonials")
      : [];

    sections.forEach(initPeguuTestimonials);
  }

  function startTestimonials() {
    initAllTestimonials(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      startTestimonials
    );
  } else {
    startTestimonials();
  }

  document.addEventListener(
    "shopify:section:load",
    function (event) {
      initAllTestimonials(event.target);
    }
  );
})();
